import BrokerSmallCaseContainer from "./BrokerSmallCaseContainer";

export default BrokerSmallCaseContainer;